export const api_url =
  process.env.REACT_APP_ENVIROMENT === "production"
    ? process.env.REACT_APP_API_URL
    : process.env.REACT_APP_API_URL_DEV;

export const api_do_url = process.env.REACT_APP_PUBLIC_IMG_URL;
